// extracted by mini-css-extract-plugin
export default {"card":"CardSellers_card__Jzt3l","header":"CardSellers_header__IRJJn","photo":"CardSellers_photo__4X3pp","name":"CardSellers_name__-xE9J","details":"CardSellers_details__3Ghi2"};